/**
 * NotificationsSkeleton — placeholder cards matching NotificationItem so the
 * list settles in place once notifications arrive.
 */
import { Skeleton, SkeletonGroup, skeletonKeys } from '../../components/ui/Skeleton';
import './notifications.css';

interface NotificationsSkeletonProps {
  count?: number;
}

export function NotificationsSkeleton({ count = 5 }: NotificationsSkeletonProps) {
  return (
    <SkeletonGroup className="notification-skeleton">
      {skeletonKeys(count).map(key => (
        <div className="notification-item" key={key} aria-hidden>
          <div className="notification-item__header">
            <Skeleton shape="circle" className="notification-skeleton__avatar" />
            <div className="notification-item__content">
              <Skeleton className="notification-skeleton__line notification-skeleton__line--title" />
              <Skeleton className="notification-skeleton__line" />
              <Skeleton className="notification-skeleton__line notification-skeleton__line--time" />
            </div>
          </div>
        </div>
      ))}
    </SkeletonGroup>
  );
}
